import React from 'react';
import User from '@westwing/ui-kit/Icons/User';
import styled from 'styled-components';
import { underTablet } from '@westwing/ui-kit/breakPoints';
import { HeaderLinkProps } from '../../../types/Navigation';
import useSignupModal from '../../hooks/useSignupModalTrigger';
import HeaderIconLink from 'Components/IconLink';

const StyledHeaderIconLink = styled(HeaderIconLink)`
    ${underTablet`
        display: none;
  `}
`;

export interface ClickableLinkProps extends HeaderLinkProps {
    onClick: (evt: React.MouseEvent) => void;
}

const AccountIcon = ({ href, ariaLabel, onClick }: ClickableLinkProps): JSX.Element => {
    const signupModalTrigger = useSignupModal();
    return (
        <StyledHeaderIconLink
            onClick={onClick}
            data-testid="oww-header-account-icon"
            href={href}
            aria-label={ariaLabel}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...signupModalTrigger}
        >
            <User />
        </StyledHeaderIconLink>
    );
};

export default AccountIcon;
